import type { ExtendedThalamosUser } from "@thalamos/aspire-common";
import { isMcaUserSession } from "@thalamos/aspire-common";

import { routeFns } from "~/routePaths.js";

/**
 * Where arriving at a patient should land.
 *
 * For an MCA team the resident page IS the patient record — the generic patient page
 * offers them forms they cannot lawfully complete — so every route into a patient ends
 * there: patient search, a PDS match, an external link. Keeping this in one place means
 * a new entry point cannot accidentally drop them on the wrong page.
 */
export function patientLandingRoute(
  user: ExtendedThalamosUser | null | undefined,
  patientId: string,
): string {
  return isMcaUserSession(user)
    ? routeFns.residentPage(patientId)
    : routeFns.patientHome(patientId);
}
